import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { CalenderIcon } from "../../../Icon";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";

import moment from "moment";
import { DropDown, RollingLoader, ToggleSwitch } from "../../../commons";

type AppProps = {
  showAddBatchNumberModal: boolean;
  option: any;
  stockItemName: any;
  toggleAddBatchNumberModal: () => void;
  batchData: any;
  handleSetStockItemName: (data: any) => void;
  handleBatchNumberChange: (data: any) => void;
  handleManufacturingDateChange: (data: any) => void;
  handleExpiryDateChange: (data: any) => void;

  uniqueNumberError: any;
  batchNumberFetching: boolean;
  batchNumberUniqueMessage: string | null;
  handleToogleStatusChange: any;
  handleSubmitBatch: () => void;
};

const AddBatchNumberModal = ({
  showAddBatchNumberModal,
  toggleAddBatchNumberModal,
  batchData,
  handleBatchNumberChange,
  handleManufacturingDateChange,
  handleExpiryDateChange,
  uniqueNumberError,
  batchNumberFetching,
  batchNumberUniqueMessage,
  option,
  stockItemName,

  handleSetStockItemName,
  handleToogleStatusChange,
  handleSubmitBatch,
}: AppProps) => {
  const filterPassedManufacturingDay = (date: Date) => {
    const today = new Date();
    return date <= today;
  };

  const filterFutureExpiryDay = (date: Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const comparisonDate = new Date(date);
    comparisonDate.setHours(0, 0, 0, 0);
    return comparisonDate >= today;
  };
  return (
    <Modal isOpen={showAddBatchNumberModal} toggle={toggleAddBatchNumberModal}>
      <ModalHeader className="pt-4 pl-4">{`Add Batch`}</ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label htmlFor="foldername">
                Batch Id <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  name="batchNumber"
                  type="text"
                  className={`form-control ${
                    !!uniqueNumberError ? "error-border" : null
                  }`}
                  value={batchData?.batchNumber}
                  onChange={handleBatchNumberChange}
                  onWheel={(event) => event.currentTarget.blur()}
                />
                {batchNumberFetching && <RollingLoader />}

                {/* {uniqueClientFetching && <RollingLoader />} */}
              </div>
              {!!uniqueNumberError && (
                <small className="text-danger">{uniqueNumberError}</small>
              )}
              {batchNumberUniqueMessage?.includes("not") &&
                !!batchData?.batchNumber?.trim()?.length && (
                  <small className="text-danger">
                    Batch number is already in use!
                  </small>
                )}
            </div>
          </div>
          <div className="d-flex mr-3">
            <div className="col-md-6 form-group mt-3 pr-0 pl-0">
              <label>
                Manufacturing Date <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative mt-1">
                <div className="date-picker-wraper mr-0 w-100">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        batchData?.manufacturingDate
                          ? new Date(
                              moment(
                                `${batchData?.manufacturingDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) =>
                        handleManufacturingDateChange(
                          e ? moment(e).format("YYYY-MM-DD") : null
                        )
                      }
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="startDate"
                      placeholderText="Choose Date"
                      className="form-control pointer"
                      filterDate={filterPassedManufacturingDay}
                    />
                    <span
                      className="calender-icon"
                      style={{ right: "25px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 form-group mt-3 pr-0 pl-0"
              style={{ marginLeft: "11px" }}
            >
              <label>
                Expiry Date <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative mt-1">
                <div className="date-picker-wraper mr-0 w-100">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={
                        batchData?.expiryDate
                          ? new Date(
                              moment(
                                `${batchData?.expiryDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) =>
                        handleExpiryDateChange(
                          e ? moment(e).format("YYYY-MM-DD") : null
                        )
                      }
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="endDate"
                      placeholderText="Choose Date"
                      className="form-control pointer"
                      filterDate={filterFutureExpiryDay}
                    />
                    <span
                      className="calender-icon"
                      style={{ right: "25px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group mt-3">
              <label>
                Stock Name <span className="color-red">*</span>
              </label>
              <div>
                <DropDown
                  extraClasses="zindex-2"
                  options={option}
                  value={stockItemName}
                  handleChange={handleSetStockItemName}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 form-group mt-3">
            <label htmlFor="Job Status" className="mb-2">
              Status
            </label>
            <ToggleSwitch
              handleToggleChange={() => handleToogleStatusChange()}
              isChecked={batchData?.status}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddBatchNumberModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleSubmitBatch();
            toggleAddBatchNumberModal();
          }}
          disabled={ !batchData?.batchNumber ||
            !batchData?.expiryDate ||
            !batchData?.manufacturingDate ||
            !stockItemName?.value || !!uniqueNumberError || (batchNumberUniqueMessage?.includes("not") )}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddBatchNumberModal;
